import type { Database } from 'node-sqlite3-wasm';

export function runCodeNavCacheWriteTransaction<T>(db: Database, fn: () => T): T {
  db.run('BEGIN IMMEDIATE');
  try {
    const result = fn();
    db.run('COMMIT');
    return result;
  } catch (e) {
    try {
      db.run('ROLLBACK');
    } catch {
      /* ignore */
    }
    throw e;
  }
}
